module.exports = __webpack_public_path__ + "static/img/service-04.dd07ee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/service-04.jpg
// module id = lhE8
// module chunks = 13